const env = process.env.NODE_ENV

// 接口域名
const serveHost = window.location.hostname.includes('www.') ? {
    development: `https://${window.location.hostname.replace('www.', 'api.')}`, // 开发环境域名
    test: `https://${window.location.hostname.replace('www.', 'api.')}`, // 测试环境域名
    production: `https://${window.location.hostname.replace('www.', 'api.')}`, // 生产环境域名
} :
    {
        development: 'https://api.apsstext.xyz', // 开发环境域名
        test: 'https://api.apsstext.xyz', // 测试环境域名
        production: 'https://api.apsstext.xyz', // 生产环境域名
    }
// const rootHost = 'https://wwwapsdev.shop'

/**
 * 根据打包指令，使用不同的接口域名，默认使用生产环境域名
 * @returns 
 */
function getServeHost() {
    // 优先读取配置文件host
    const host = serveHost[env]
    return host ? host : serveHost[env]

}



export default {
    ROOT_HOST: getServeHost(),
    VUE_APP_SERVER: getServeHost(), // http://192.168.2.45:766, https://cloud-api.shuandigital.cn
    IS_DEBUGGER: env === 'development',
    WSHOST: window.location.hostname.includes('www.') ? `wss://${window.location.hostname.replace('www.', 'api.')}` : 'wss://api.apsstext.xyz',
};





// WEBPACK FOOTER //
// ./src/request/settings.js